import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import {
  loadRequiredActionsRequest,
  loadRequiredActionsSuccess,
  loadRequiredActionsFail,
  validateProspectsRequest,
  validateProspectsSuccess,
  validateProspectsFail,
  resetErrors,
  resetProspects,
} from './requiredActions.actions';
import { IProspects, IRequiredAction } from './requiredActions.types';

export interface IRequiredActionsState {
  isLoading: boolean;
  isLoaded: boolean;
  actions: IRequiredAction[];
  isValidated: boolean;
  prospects: IProspects | null;
  errors: TLegacyErrors<IProspects>;
}

export const initialState: IRequiredActionsState = {
  isLoading: false,
  isLoaded: false,
  actions: [],
  isValidated: false,
  prospects: null,
  errors: {},
};

const reducer = createReducer<IRequiredActionsState>({}, initialState);

reducer
  .on(loadRequiredActionsRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(loadRequiredActionsSuccess, (state, payload) => ({
    ...state,
    isLoaded: true,
    isLoading: false,
    actions: payload,
  }))
  .on(loadRequiredActionsFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer
  .on(validateProspectsRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(validateProspectsSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    isValidated: true,
    prospects: payload,
  }))
  .on(validateProspectsFail, (state, payload) => ({
    ...state,
    isLoading: false,
    errors: payload,
  }));

reducer
  .on(resetErrors, state => ({
    ...state,
    isValidated: false,
    prospects: null,
    errors: {},
  }))
  .on(resetProspects, state => ({
    ...state,
    isValidated: false,
    prospects: null,
    errors: {},
  }));

export default reducer;
